import { useIsCardPageV2Enabled } from '@repo/ccc-main-app-lib/src/lib/useIsCardPageV2Enabled.ts'
import { LivePayTransfersPage } from '@repo/ccc-main-app-lib/src/pages/LivePayTransfersPage.tsx'
import { Loader } from '@repo/internal-tools-design-system/src/lib/Loader/Loader.tsx'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute(
  '/_authenticated/user/$userId/live-pay/transfers',
)({
  component: UserLivePayTransfersPage,
})

function UserLivePayTransfersPage() {
  const { userId } = Route.useParams()
  const navigate = useNavigate()

  const shouldUseCardPageV2 = useIsCardPageV2Enabled()

  useEffect(() => {
    if (!shouldUseCardPageV2) {
      void navigate({
        to: '/user/$userId/card',
        params: { userId },
        replace: true,
      })
    }
  }, [navigate, shouldUseCardPageV2, userId])

  if (!shouldUseCardPageV2) {
    return (
      <Loader size="sm" withContainer isFullPage>
        Redirecting...
      </Loader>
    )
  }

  return <LivePayTransfersPage userId={userId} />
}
